import { createAction } from "@reduxjs/toolkit";

const showModal = createAction('modal/showModal');

export default showModal;

